/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { observer } from 'mobx-react';
import { Tabs, TabPanel } from 'ca-ui-toolkit';
import classnames from 'classnames';
import StringResources from 'nls/StringResources';


@observer
class FieldsListLayout extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		return this.renderFields();
	}

	renderFields() {
		const fields = this.props.fields.map(field => this.renderField(field));
		let content;
		if(fields.length === 0) {
			content = '';
		} else {
			content = (
				<Tabs
					//deleteable currently doesn't work as intended (tabs can ALWAYS be deleted even when this is false), but ba-ui-toolkit team should fix it soon
					deleteable={true}
					tabButton={true}
					selected={this.props.focus.id}
					scrollWhenSelected = {true}
					onChange={tabId => this.props.onClick(tabId)}
					stateTabs={fields}
					setState={(option) => {
						this._setInterestingFields(option);
					}}
				>
					{fields}
				</Tabs>
			);
		}

		return (
			<div className={classnames('explore-fieldList')}>
				{ content }
			</div>
		);
	}

	renderField(field) {
		const fieldTitle = ` (${StringResources.get('tooltipId')}: ${field.id})`;
		return (
			<TabPanel
				id={field.id}
				label={field.name}
				key={field.id}
				title= {field.name + fieldTitle}
			/>
		);
	}

	_setInterestingFields(newFields){
		const fields = newFields.map(field => {
			return({
				name: field.props.label,
				id: field.props.id
			});
		});
		this.props.onFieldsChanged(fields);
	}
}

FieldsListLayout.propTypes = {
	fields: PropTypes.observableArrayOf(PropTypes.object).isRequired,
	focus: PropTypes.object,
	onClick: PropTypes.func,
	onFieldsChanged: PropTypes.func
};

FieldsListLayout.defaultProps = {
	fields: [],
	focus: 0,
	onClick: () => {},
	onFieldsChanged: () => {}
};

export default FieldsListLayout;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/FieldsListLayout.js